import React, { useEffect, useState } from "react";
import { Styles } from "./styles";
import { Col, Container, Row } from "react-bootstrap";
import Tag from "../../../assets/images/backGrounds/tag.svg";
import SemiColumn from "../../../assets/images/backGrounds/semicolumn.svg";
import CircleBG from "../../../assets/images/backGrounds/circle.webp";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import Activity from "../../activity/Activity";
import { t } from "i18next";
import { getAllActivities } from "../../../services/activities.service";
import Error from "../../common/error/Error";
import Loader from "../../common/loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import { Fade } from "react-reveal";
import RubberBand from "react-reveal/RubberBand";
import { setRefreshActivities } from "../../../store/slices/activitySlice";

const Activities = () => {
  // language data from store
  const Resource = useSelector((state) => state.translation.resource);
  const refreshActivities = useSelector(
    (state) => state.activity.refreshActivities
  );
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState();

  const getData = async () => {
    setIsLoading(true);
    const response = await getAllActivities({
      enablePagination: false,
    });
    if (response?.status === 200) {
      setData(response?.data?.data?.list);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (refreshActivities) {
      getData();
      dispatch(setRefreshActivities(false));
    }
  }, [refreshActivities]);

  return (
    <Styles>
      {isLoading ? (
        <Loader paddingTop={"125px"} />
      ) : (
        data?.length > 0 && (
          <section id="activitiesSection">
            <RubberBand>
              <img className="tag" src={Tag} alt="tag image" />
            </RubberBand>
            <img
              className="semi-column"
              src={SemiColumn}
              alt="semi column image"
            />
            {/* {data?.length > 2 && (
            <img className="circle-bg" src={CircleBG} alt="circle image" />
          )} */}
            <Container>
              <Fade bottom>
                <h2 className="section-title">
                  {Resource?.activities_title
                    ? Resource?.activities_title
                    : t("home.activities.title")}
                </h2>
              </Fade>
              {data?.length > 2 ? (
                <Swiper
                  navigation={true}
                  modules={[Navigation]}
                  loop={true}
                  breakpoints={{
                    0: {
                      slidesPerView: 1,
                      centeredSlides: true,
                    },
                    768: {
                      slidesPerView: 2,
                      centeredSlides: false,
                    },
                    992: {
                      slidesPerView: 3,
                      centeredSlides: true,
                    },
                  }}
                >
                  {data?.map((item, idx) => {
                    return (
                      <SwiperSlide key={idx}>
                        <Activity data={item} />
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
              ) : (
                <Row className="activities-container">
                  {data?.map((item, idx) => {
                    return (
                      <Col xl={4} md={6} sm={9} key={idx}>
                        <Activity data={item} />
                      </Col>
                    );
                  })}
                </Row>
              )}
            </Container>
          </section>
        )
      )}
    </Styles>
  );
};

export default Activities;
